import { Button, ButtonProps } from '@/components/form/baseInputs/Button';
import { COLORS } from '@/styles/tokens/colors';

export const CONTROL_BUTTON_ICON_SIZE = 16;

export type ControlButtonProps = Partial<ButtonProps>;
export const ControlButton = ({
  size = 'sm',
  variant = 'primary',
  square = true,
  iconProps: externalIconProps,
  sx,
  ...props
}: ControlButtonProps) => {
  const iconProps =
    props.startIcon || props.endIcon
      ? { size: CONTROL_BUTTON_ICON_SIZE, ...externalIconProps }
      : externalIconProps;

  return (
    <Button
      size={size}
      variant={variant}
      square={square}
      iconProps={iconProps}
      data-is-flow-chart-control-button
      sx={{
        // we have this special handling because these buttons are rendered "combined" with other buttons
        // so it looks weird if the disabled ones have different borders
        '&:disabled': {
          borderColor: COLORS.GRAY[300],
        },
        ...sx,
      }}
      {...props}
    />
  );
};
